export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB']
  let value = bytes / 1024
  let i = 0
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024
    i++
  }
  return `${value.toFixed(value < 10 ? 1 : 0)} ${units[i]}`
}

const UNITS: [number, Intl.RelativeTimeFormatUnit][] = [
  [60, 'second'],
  [60, 'minute'],
  [24, 'hour'],
  [7, 'day'],
  [4.35, 'week'],
  [12, 'month'],
  [Number.POSITIVE_INFINITY, 'year'],
]

const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto', style: 'narrow' })

/** unix seconds -> "3 mo. ago", for blame gutters and file listings */
export function relativeTime(seconds: number): string {
  let amount = (Date.now() - seconds * 1000) / 1000
  for (const [step, unit] of UNITS) {
    if (Math.abs(amount) < step) return relative.format(-Math.round(amount), unit)
    amount /= step
  }
  return relative.format(-Math.round(amount), 'year')
}

/** unix seconds -> 2016-08-28, the fixed-width form a blame gutter wants */
export function isoDate(seconds: number): string {
  const date = new Date(seconds * 1000)
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
